import React from 'react';

import springboard from 'springboard';
import {useModals} from '../music_sniper/components/modals/modals_provider';

export type SidebarComponentConfig = {
    label: string;
    icon: React.FunctionComponent;
    link?: string;
    onClick?: (modals: ReturnType<typeof useModals>) => void;
    links?: Array<{
        id: string;
        label: string;
        link: string;
    }>;
};

export type SettingsComponentConfig = {
    label: string;
    icon: React.ElementType<{size: number; style?: React.CSSProperties}>;
    onClick: (modals: ReturnType<typeof useModals>) => void;
};

declare module 'springboard/module_registry/module_registry' {
    interface AllModules {
        UIEntrypoints: UIEntrypointsModuleReturnValue;
    }
}

type UIEntrypointsModuleReturnValue = {
    sidebar: {
        registerComponent: (sidebarComponent: SidebarComponentConfig) => void;
        components: SidebarComponentConfig[];
    };
    settings: {
        registerComponent: (settingsComponent: SettingsComponentConfig) => void;
        components: SettingsComponentConfig[];
    }
};

springboard.registerModule('UIEntrypoints', {}, async (moduleAPI): Promise<UIEntrypointsModuleReturnValue> => {
    const sidebarComponents: SidebarComponentConfig[] = [];
    const settingsComponents: SettingsComponentConfig[] = [];

    return {
        sidebar: {
            registerComponent: (sidebarComponent: SidebarComponentConfig) => {
                sidebarComponents.push(sidebarComponent);
            },
            components:sidebarComponents,
        },
        settings: {
            registerComponent: (settingsComponent: SettingsComponentConfig) => {
                settingsComponents.push(settingsComponent);
            },
            components: settingsComponents,
        },
    };
});
